module.exports = __webpack_public_path__ + "static/media/right_angle_trig.1b3ab60d.pdf";